import React from 'react';
import styled from 'styled-components';
import qs from 'querystringify';
import { omit } from 'lodash';
import { Level } from 'rbx';

import { Input, Radio } from '../../../components/elements';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const Search = ({
  placeName,
  itemName,
  setItemName,
  history,
  routeState,
  saleType,
  showFilters,
}) => {
  const handlePush = (args, key) => {
    const newRoutState = omit(routeState, key);
    history.push(
      `/bulk-menu-item/${placeName}${qs.stringify(
        {
          ...newRoutState,
          ...args,
        },
        true,
      )}`,
    );
  };

  return (
    <Wrapper>
      {showFilters && (
        <Level>
          <Level.Item align="left">
            <Level.Item>
              <div>
                <Radio
                  label="All Items"
                  value={saleType === 'ALL'}
                  onChange={() => {
                    handlePush({ saleType: 'ALL' }, 'saleType');
                  }}
                />
              </div>
            </Level.Item>
            <Level.Item>
              <div>
                <Radio
                  label="Item"
                  value={saleType === 'ITEM'}
                  onChange={() => {
                    handlePush({ saleType: 'ITEM' }, 'saleType');
                  }}
                />
              </div>
            </Level.Item>
            <Level.Item>
              <div>
                <Radio
                  label="Modifier"
                  value={saleType === 'MODIFIER'}
                  onChange={() => {
                    handlePush({ saleType: 'MODIFIER' }, 'saleType');
                  }}
                />
              </div>
            </Level.Item>
            <Level.Item>
              <div>
                <Radio
                  label="Deal"
                  value={saleType === 'DEAL'}
                  onChange={() => {
                    handlePush({ saleType: 'DEAL' }, 'saleType');
                  }}
                />
              </div>
            </Level.Item>
          </Level.Item>
        </Level>
      )}
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-4">
            <Input
              label="Place Name"
              type="text"
              value={placeName}
              placeholder="Start entering place name..."
              required
              disabled
            />
          </div>
          {showFilters && (
            <div className="column is-4">
              <Input
                label="Item Name"
                type="text"
                value={itemName}
                onChange={event => setItemName(event.target.value)}
                placeholder="Start entering item Name..."
              />
            </div>
          )}
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};
export default Search;
